import { render, staticRenderFns } from "./MoveBallon.vue?vue&type=template&id=7fa4b5d4&scoped=true&"
import script from "./MoveBallon.vue?vue&type=script&lang=js&"
export * from "./MoveBallon.vue?vue&type=script&lang=js&"
import style0 from "./MoveBallon.vue?vue&type=style&index=0&id=7fa4b5d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa4b5d4",
  null
  
)

export default component.exports